@if (allowanceEntity$ | async) {
  @if(hasKinderen) {
    <form (change)="saveForm()" [formGroup]="formGroup">
      <div formArrayName="kinderen">
        @for (kindGroup of kinderen.controls; track kindGroup; let i = $index) {
          @if (isJongerDan13Jaar(kindGroup.controls.geboortedatum.value)) {
            <div [formGroupName]="i">
              <div formArrayName="opvangPerKind">
                @for (periodeGroup of getOpvangPeriodes(i).controls; track periodeGroup; let j = $index) {
                  <div [formGroupName]="j">
                    <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                      <snelstart-ui-text-form-control [label]="j === 0 ? 'Omschrijving' : ''"
                                                      class="custom-input-125"
                                                      formControlName="naamKinderopvanginstelling"
                                                      id="naamKinderopvanginstelling-{{ i }}-{{ j }}"
                      >
                      </snelstart-ui-text-form-control>
                      <div class="row col-auto" formGroupName="periodeOpvang" style="--bs-gutter-x: 0.5rem;">
                        <snelstart-ui-date-form-control [label]="j === 0 ? 'Opvang van' : ''"
                                                        class="custom-input-150"
                                                        formControlName="begindatum"
                                                        id="begindatum-{{ i }}-{{ j }}"
                                                        placeholder="dd-mm-{{ this.year }}"
                        >
                        </snelstart-ui-date-form-control>
                        <snelstart-ui-date-form-control [label]="j === 0 ? 'Opvang t/m' : ''"
                                                        class="custom-input-150"
                                                        formControlName="einddatum"
                                                        id="einddatum-{{ i }}-{{ j }}"
                                                        placeholder="dd-mm-{{ this.year }}"
                        >
                        </snelstart-ui-date-form-control>
                      </div>
                      <snelstart-ui-bsn-form-control [label]="j === 0 ? 'LRK nummer' : ''"
                                                     class="custom-input-100"
                                                     formControlName="identificatienummerInstelling"
                                                     id="identificatienummerInstelling-{{ i }}-{{ j }}"
                      >
                      </snelstart-ui-bsn-form-control>
                      <snelstart-ui-number-form-control [label]="j === 0 ? 'Uren p/mnd' : ''"
                                                        [showAllDecimals]="false"
                                                        class="custom-input-100"
                                                        formControlName="urenPerMaand"
                                                        id="urenPerMaand-{{ i }}-{{ j }}"
                      >
                      </snelstart-ui-number-form-control>
                      <snelstart-ui-number-form-control [label]="j === 0 ? 'Uurprijs' : ''"
                                                        [showAllDecimals]="true"
                                                        align="right"
                                                        class="custom-input-100"
                                                        formControlName="uurprijs"
                                                        id="uurprijs-{{ i }}-{{ j }}"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                      <snelstart-ui-select-form-control [label]="j === 0 ? 'Vorm' : ''"
                                                        [options]="opvangVorm"
                                                        class="custom-input-150"
                                                        formControlName="opvangVorm"
                                                        id="opvangVorm-{{ i }}-{{ j }}"
                      >
                      </snelstart-ui-select-form-control>
                      <snelstart-ui-select-form-control [label]="j === 0 ? 'Soort' : ''"
                                                        [options]="opvangSoort"
                                                        class="custom-input-150"
                                                        formControlName="soortOpvang"
                                                        id="soortOpvang-{{ i }}-{{ j }}"
                      >
                      </snelstart-ui-select-form-control>
                      <snelstart-ui-button (click)="verwijderRij(i, j)"
                                           [class]="j === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                           icon="trash"
                                           iconType="light"
                                           id="buttonDelete-{{ i }}-{{ j }}"
                                           size="medium"
                                           type="secondary"
                      >
                      </snelstart-ui-button>
                    </div>
                  </div>
                }
              </div>
              <snelstart-ui-button (click)="addRij(i)" class="snelstart-ui-button pb-3" icon="plus"
                                   type="link">
                @if (getOpvangPeriodes(i).length === 0) {
                  Gegevens opvang voor {{ kindGroup.controls.voornaam.value }} invullen
                } @else {
                  Opvanggegevens voor {{ kindGroup.controls.voornaam.value }} toevoegen
                }
              </snelstart-ui-button>
            </div>
          }
        }
      </div>
    </form>
  } @else {
    <p>Er zijn geen kinderen gevonden.</p>
  }

}
